/**
 * Design System - Dark Charcoal Theme
 * Premium, timeless, executive-level portfolio
 */

export const theme = {
    // Core Colors - Dark Charcoal
    primary: '#FFFFFF',           // White - Headings, primary text on dark
    secondary: '#0D1117',         // Deep charcoal - Page background
    tertiary: '#161B22',          // Elevated surfaces

    // Accent Colors - Steel Blue
    accent: '#58A6FF',            // Primary accent - CTAs, links
    accentHover: '#79C0FF',       // Hover state
    accentMuted: '#1F6FEB',       // Muted accent for borders

    // Distinction accent - Gold (used sparingly for honors, awards, IEEE)
    accentGold: '#E3B341',
    accentGoldMuted: 'rgba(227, 179, 65, 0.12)',

    // Gradient for headline emphasis / hero
    gradient: 'linear-gradient(120deg, #79C0FF 0%, #58A6FF 45%, #6E8BFF 100%)',

    // Text Colors
    textPrimary: '#F0F6FC',       // Primary text
    textSecondary: '#9DA7B3',     // Muted text, captions
    textTertiary: '#848D97',      // Very muted

    // Surface Colors
    cardBg: '#21262D',            // Card backgrounds
    cardBgHover: '#30363D',       // Card hover
    border: '#30363D',            // Borders
    divider: '#21262D',           // Dividers

    // Status Colors
    success: '#3FB950',
    error: '#F85149',
    warning: '#D29922',

    // Typography
    fonts: {
        main: "'Poppins', sans-serif",
        code: "'Fira Code', monospace"
    },

    // Spacing System
    spacing: (factor) => `${0.25 * factor}rem`,

    // Shadows (darker for dark theme)
    shadows: {
        sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
        md: '0 4px 12px rgba(0, 0, 0, 0.4)',
        lg: '0 8px 24px rgba(0, 0, 0, 0.5)',
        xl: '0 12px 40px rgba(0, 0, 0, 0.6)',
        glow: '0 0 20px rgba(88, 166, 255, 0.15)',
    },

    // Border Radius
    shape: {
        borderRadius: '8px',
        borderRadiusLg: '12px',
        borderRadiusXl: '16px',
    },

    // Transitions
    transitions: {
        fast: '150ms ease',
        normal: '200ms ease',
        slow: '300ms ease',
    }
};

// Button Styles
export const buttonStyles = {
    primary: {
        background: theme.accent,
        color: '#FFFFFF',
        border: 'none',
        hoverBg: theme.accentHover,
    },
    secondary: {
        background: 'transparent',
        color: theme.accent,
        border: `1px solid ${theme.accent}`,
        hoverBg: theme.accent,
        hoverColor: '#FFFFFF',
    },
    ghost: {
        background: 'transparent',
        color: theme.textSecondary,
        border: 'none',
        hoverColor: theme.primary,
    }
};
